/**
 * <withdrawal-form>
 *
 * Shows or hides the "item or part of the order" field of the withdrawal
 * (Widerruf) form depending on the option chosen in the scope select.
 *
 * The option that reveals the field is flagged in the markup with
 * `data-reveal`, not matched by its value, so the logic keeps working once
 * the option text is translated.
 *
 * Without JavaScript the field stays visible and usable: hiding is done by
 * the section CSS via `withdrawal-form:defined`, which only applies once
 * this file has run.
 */
if (!customElements.get('withdrawal-form')) {
  customElements.define(
    'withdrawal-form',
    class WithdrawalForm extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-scope]');
        this.field = this.querySelector('[data-conditional]');
        this.input = this.querySelector('[data-conditional-input]');

        if (!this.select || !this.field || !this.input) return;

        this.onChange = this.onChange.bind(this);
        this.select.addEventListener('change', this.onChange);
        this.onChange();
      }

      disconnectedCallback() {
        if (this.select && this.onChange) this.select.removeEventListener('change', this.onChange);
      }

      onChange() {
        const option = this.select.options[this.select.selectedIndex];

        if (option && option.hasAttribute('data-reveal')) {
          this.field.setAttribute('data-visible', '');
          this.input.disabled = false;
          return;
        }

        this.field.removeAttribute('data-visible');
        this.input.value = '';
        this.input.disabled = true;
      }
    }
  );
}
